/* eslint-disable react/require-default-props */
import { useState } from 'react';
import { icons } from '~/assets';
import useApi, { ApiMethod } from '~/hooks/useApi';
import endpoints from '~/services/endpoints';
import { IDefaultReturn, cpfMask } from '~/utils/masks';
import Dialog, { IDialog } from '../dialog';
import Input from '../input';

type IPasswordDialogProps = {
  onSuccessValidation: Function;
  // eslint-disable-next-line react/require-default-props
  onErrorValidation?: Function;
  onClose?: Function;
  isLoading?: boolean;
  setLoading?: (value: boolean) => void;
} & IDialog;
const PasswordModal = ({
  positiveAction,
  onSuccessValidation,
  onErrorValidation,
  negativeAction,
  onClose,
  isLoading,
  setLoading,
  ...props
}: IPasswordDialogProps) => {
  const [modalOpen, setModalOpen] = useState(true);
  const [modalError, setModalError] = useState({ open: false, message: '' });
  const user = JSON.parse(localStorage.getItem('@NovaEra:user'));
  const [cpf] = useState<IDefaultReturn>(cpfMask(user?.cpf) as IDefaultReturn);
  const [senha, setSenha] = useState('');

  const AuthValidatePassword = useApi<any>(
    endpoints.account.validateUserPassword,
    ApiMethod.POST,
  );
  const hiddeCPFNumber = (value) => {
    const valueSplited = value.split('');

    return valueSplited
      .map((el, index) => {
        if (index > 3 && index < 11) return '*';
        return el;
      })
      .join('');
  };
  const handlePasswordValidate = async () => {
    setLoading?.(true);
    try {
      const { status, mensagem } = await AuthValidatePassword.callApi({
        cpf: cpf.unmasked,
        senha,
      });
      if (status >= 200 && status <= 300) {
        onSuccessValidation();
        setModalOpen(false);
        setLoading?.(false);
      } else {
        onErrorValidation && onErrorValidation();
        setModalOpen(false);
        setModalError({ open: true, message: mensagem });
        setLoading?.(false);
      }
    } catch (err) {
      setModalError({ open: true, message: err.mensagem });
      setLoading?.(false);
      console.log(err);
    }
  };
  return (
    <>
      <Dialog
        widthInPercent={30}
        open={modalOpen}
        positiveLabel="Confirmar"
        negativeLabel="Voltar"
        Loading={AuthValidatePassword.loading}
        negativeAction={() => {
          setModalOpen(false);
          onClose();
        }}
        positiveAction={handlePasswordValidate}
        icon={icons.warning}
        title="Insira sua senha"
        {...props}
        buttonDisabledPositive={
          senha.length !== 6 ||
          AuthValidatePassword.loading ||
          props?.buttonDisabledPositive
        }
      >
        <Input
          id="cpf"
          name="cpf"
          type="text"
          label="CPF"
          maxLength={14}
          value={hiddeCPFNumber(cpf.masked)}
        />
        <Input
          type="password"
          label="Senha"
          autoComplete="new-password"
          autoCorrect="none"
          maxLength={6}
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
      </Dialog>
      <Dialog
        open={modalError.open}
        title={modalError.message}
        positiveAction={() => {
          setModalError({ open: false, message: '' });
          onClose();
        }}
        positiveLabel="Entendi"
        icon={icons.warning}
      />
    </>
  );
};

export default PasswordModal;
